<template>
  <bg-style v-if="enabled" :is-disabled="$store.getters.isStandAloneMode" class="single-goods" :class="{ 'is-mobile': $store.getters.isMobile }" :mobile-bg="model.mobileBackground" :bg="model.background">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <rich-text v-if="model.titleVisible" v-model="model.title" :disabled="!editing" :editing="editing" :stroke.sync="model.titleStroke" class="w-full relative title" theme="snow"/>
      <rich-text v-if="model.subtitleVisible" v-model="model.subtitle" :disabled="!editing" :editing="editing" :stroke.sync="model.subTitleStroke" class="mt-3 desc relative" theme="snow"/>
      <div class="single-goods__list relative" :class="{'justify-center': model.layout === '1', 'grid-cols-2': model.layout === '2' && !$store.getters.isMobile }">
        <template v-for="(item, index) in model.children">
          <model-wrapper v-if="item.visible && getGoods(item.goodsId)" :key="`${index}` + item.goodsId" :parent-model="model" :model="item">
            <good-item :good="getGoods(item.goodsId)" :model="model" :editing="editing" :is-mobile="$store.getters.isMobile" :store-lang="storeLang" :good-model="item" @item-click="handleItemClick" @buy="onItemBuy" />
          </model-wrapper>
        </template>
      </div>
    </module-block>
    <goods-detail v-if="showDetail" ref="$detail" class="single-goods-detail" :model="currentGoodsModel" :site="site" :is-mobile="$store.getters.isMobile" :good="currentGoods" :store-lang="storeLang" @buy="onSubmitOrder" @close="showDetail = false" />
    <DeskPayModal
      v-if="deskPay.visible"
      :desk-pay="deskPay"
      :store-lang="storeLang"
      :lang-id-data="$store.state.locale.langIdData"
      @close="closePay"
    />
  </bg-style>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import {Message} from 'element-ui'
import GoodItem from './goodsItem.vue'
import RichText from '~/components/richText/index.vue'
import tools, {checkIgnoreMessage, checkUser, generateOrderParams, generatePayUrl} from "~/utils"
import GoodsDetail from '~/site/widgets/storeWidget/detail.vue'
import {selectWidgetMenu} from '~/site/core'
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import Bus from '~/site/model/bus'
import {DefaultImage} from '~/enums/defaultImageEnum'
import ModelWrapper from '~/components/modelWrapper/index.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import { BusEventMap } from '~/enums/data'
export default {
  name: 'SingleGoodsWidget',
  components: { ModuleBlock, ModelWrapper, DeskPayModal, GoodsDetail, RichText, GoodItem},
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      enabled: false,
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      },
      orderLoading: false,
      storeLang: '',
      showDetail: false,
      currentGoodsModel: {},
      currentGoods: {}
    }
  },
  computed: {
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    }
  },
  created() {
    this.init()
  },
  mounted() {
    Bus.$on('reloadGood', (type) => {
      const isLogin = type === 'login'
      if (isLogin) {
        this.checkBuy()
      }
    })
  },
  methods: {
    checkEnabled() {
      if (this.editing) {
        this.enabled = true
      } else {
        this.enabled = this.model.children.some(item => item.visible && this.getGoods(item.goodsId))
      }
    },
    getGoods(id) {
      const empty = {
        names: {
          lang_id: 'Name'
        },
        icon: DefaultImage.store,
        corner: DefaultImage.Corner,
        description: 'Description'
      }
      const goodsList = cloneDeep(this.$store.state.goods.goodsList)
      const current = goodsList.find(item => item.id === id)
      return current || (this.editing ? empty : null)
    },
    checkBuy() {
      const isAim = this.awaitGoods && (this.awaitGoods.modelId === this.model.id)
      if (isAim) this.createOrder(this.awaitGoods.data)
    },
    async init() {
      this.storeLang = tools.getStoreLang(this)
      await this.$store.dispatch('goods/getGroupList', this)
      await this.$store.dispatch('goods/getGoodsByGroups', this)
      this.checkEnabled()
    },
    handleOpenMenu(goodModel, index) {
      if (this.editing) selectWidgetMenu(this, this.model, goodModel, index)
    },
    async onSubmitOrder() {
      if (this.orderLoading) return
      await checkUser(this, () => {
        this.showDetail = false
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: cloneDeep(this.currentGoods) })
      })
      await this.createOrder()
    },
    onItemBuy(goods) {
      this.currentGoods = goods
      this.onSubmitOrder()
    },
    async createOrder(goods) {
      this.showDetail = false
      this.orderLoading = true
      const [err, res] = await this.$utils.to(generateOrderParams(this, goods || this.currentGoods))
      this.orderLoading = false
      if (!err) {
        this.$store.commit('site/SET_AWAIT_GOODS', null)
        generatePayUrl(res, this)
      } else {
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    closePay() {
      this.$store.commit('site/SET_SHOP_GOOD', null)
      Bus.$emit('reloadActivity', BusEventMap.Payment)
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    },
    handleItemClick(goods, goodsModel) {
      if (this.editing) return
      const model = {
        buyBackground: goodsModel.buttonBackground,
        goodsTitleColor: goodsModel.nameBackground.backgroundColor,
        goodsTitleColorShow: goodsModel.nameBackground.backgroundColorShow,
        goodsPriceColor: goodsModel.priceBackground.backgroundColor,
        goodsPriceColorShow: goodsModel.priceBackground.backgroundColorShow,
        ...goodsModel
      }
      if (!model?.infoBackground?.backgroundColor) {
        model.infoBackground.backgroundColor = model.background.backgroundColor
      }
      this.currentGoods = goods
      this.currentGoodsModel = model
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.$detail.init()
      })
    }
  }
}
</script>

<style lang="less">
.single-goods {
  padding: 20px 0;
  &__list {
    display: grid;
    margin-top: 40px;
    gap: 32px;
    .model-widget {
      width: 593px;
    }
  }
  &.is-mobile {
    padding: 10px;
    .single-goods__list {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 16px 0;
      padding: 0 5px;
      .model-widget {
        width: 100%;
      }
    }
  }
}
</style>
